import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import BaseInput from "./BaseInput";
import withFormHandlers from "./withFormHandlers";
import compose from "recompose/compose";
import branch from "recompose/branch";
import Checkbox from "./Checkbox";
import NumberInput from "./NumberInput";

export { BaseInput };

const Input = (props) => {
  const {
    getErrors,
    isPristine,
    isValid,
    isDirty,
    appearance,
    inputSize,
    baseInputProps,
    help,
    autocomplete,
    autoComplete,
    suggestions,
    ...rest
  } = props;

  if (props.type === "hidden") {
    return <input {...rest} />;
  }

  const classes = classNames({
    "input--invalid": getErrors().length,
    "input--valid": isValid(),
    [`input--${inputSize}`]: inputSize,
  });

  return (
    <BaseInput
      appearance={appearance}
      input={
        <input
          className={classes}
          autoComplete={autoComplete || autocomplete || "on"}
          {...rest}
        />
      }
      suggestions={suggestions}
      help={help}
      errors={getErrors()}
      {...baseInputProps}
    />
  );
};

Input.defaultProps = {
  appearance: "default",
};

Input.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  appearance: BaseInput.propTypes.appearance,
  type: PropTypes.oneOf([
    "text",
    "email",
    "tel",
    "checkbox",
    "radio",
    "hidden",
    "password",
    "number",
    "url",
  ]).isRequired,
  placeholder: PropTypes.string,
  inputSize: PropTypes.oneOf(["default", "short", "medium"]),
  baseInputProps: PropTypes.object,
  suggestions: PropTypes.object,
};

export default compose(
  branch(
    (props) => props.type === "checkbox",
    () => Checkbox,
    branch(
      (props) => props.type === "number",
      () => NumberInput,
      (BaseComponent) => BaseComponent
    )
  ),
  withFormHandlers()
)(Input);
